export { SearchTabs, type SearchTabsProps } from './SearchTabs';
